import { a as r } from "../internals/array-buffer-view-core.js";
import { f as a } from "../internals/function-uncurry-this.js";
import { a as t } from "../internals/a-callable.js";
import { a as o } from "../internals/array-from-constructor-and-list.js";
var e = r.aTypedArray,
  s = r.getTypedArrayConstructor,
  n = r.exportTypedArrayMethod,
  i = a(r.TypedArrayPrototype.sort);
n("toSorted", function (r) {
  void 0 !== r && t(r);
  var a = e(this);
  return i(o(s(a), a), r);
});